(ns manage.ad-variant.creation.ad-builder.card-group-item
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Radio$default" :as Radio]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            [uix.core :refer [$ defui]]))

(defui card-group-item
  [{:keys [thumbnail title description value selected-value on-click]}]
  (let [selected (= value selected-value)
        color (if selected "primary.main" "primary.dark")
        background-color (if selected "primary.100" "white")]
    ($ Tooltip {:title "The format for this template has already been assigned"
                :placement "top"}
       ($ Box {:width 182
               :on-click #(on-click value)
               :sx #js {:minHeight 192
                        :border 2
                        :borderColor (if selected "blue" "#14082040")
                        :backgroundColor background-color
                        :borderRadius 2}}
          ($ Radio {:checked selected
                    :sx #js {:position "absolute"}})
          ($ Stack {:direction "column"
                    :disabled true
                    :alignItems "center"
                    :sx #js {:p 2}}
             ($ thumbnail {:width 88 :height 88})
             ($ Typography {:variant "h5"
                            :sx #js {:color color
                                     :paddingTop 1}}
                title)
             ($ Typography {:variant "body2"
                            :width 160
                            :textAlign "center"}
                description))))))
